import React, { useState, useEffect } from 'react'
import './hero-rotator.css'

export default function HeroRotator({ images = [], interval = 2000 }) {
  const [index, setIndex] = useState(0)

  useEffect(() => {
    if (!images || images.length === 0) return
    const id = setInterval(() => setIndex(i => (i + 1) % images.length), interval)
    return () => clearInterval(id)
  }, [images, interval])

  return (
    <div className="hero-rotator" aria-hidden="true">
      {images.map((img, i) => (
        <div
          key={i}
          className={"slide" + (i === index ? ' active' : '')}
          style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/${img})` }}
        />
      ))}
    </div>
  )
}
